/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type EventStatusKind = "canceled" | "completed" | "draft" | "ended" | "live" | "started" | "%future added value";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type CreateUpdatePitchRequestInput = {
    readonly clientMutationId?: string | null;
    readonly id?: string | null;
    readonly description?: string | null;
    readonly investmentUrl?: string | null;
    readonly previews?: ReadonlyArray<CreatePreviewInput> | null;
    readonly force?: boolean | null;
    readonly revision?: string | null;
    readonly item: string;
    readonly isDeleted?: boolean | null;
    readonly tags?: ReadonlyArray<string> | null;
    readonly plan?: CreatePaymentSubscriptionInput | null;
    readonly peopleEntities?: ReadonlyArray<CreateEntityPersonInput> | null;
    readonly save?: boolean | null;
};
export type CreatePreviewInput = {
    readonly kind?: ReadonlyArray<string> | null;
    readonly link?: string | null;
    readonly mediaAsset?: string | null;
};
export type CreatePaymentSubscriptionInput = {
    readonly priceId: string;
    readonly quantity?: number | null;
    readonly promoCode?: string | null;
};
export type CreateEntityPersonInput = {
    readonly entity?: string | null;
    readonly person?: string | null;
};
export type createRsvpRequestMutationVariables = {
    readonly input: CreateUpdatePitchRequestInput;
};
export type createRsvpRequestMutationResponse = {
    readonly createRSVPRequest: {
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly userRequest: ({
            readonly id?: string;
            readonly __typename: "RSVPRequest";
            readonly status?: string | null;
            readonly item?: ({
                readonly __typename: "Event";
                readonly id?: string;
                readonly name?: string | null;
                readonly description?: string | null;
                readonly end?: unknown | null;
                readonly start?: unknown | null;
                readonly status?: EventStatusKind | null;
                readonly externalId?: string | null;
                readonly mediaExternalId?: string | null;
                readonly created?: unknown | null;
                readonly previews?: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly people?: ReadonlyArray<{
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly landingPageUrl: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly entities?: ReadonlyArray<{
                    readonly __typename: string;
                    readonly id: string;
                    readonly name: string | null;
                    readonly description: string | null;
                    readonly landingPageUrl: string | null;
                    readonly founded: unknown | null;
                    readonly industry: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly noOfEmployees: {
                        readonly maximum: number | null;
                        readonly minimum: number | null;
                        readonly isGreaterThan: boolean | null;
                        readonly isLessThan: boolean | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly pitchOriginalMedia: {
                        readonly id: string;
                    } | null;
                    readonly opportunities: {
                        readonly productAndServices: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly careers: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly collaboration: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                    } | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly pageInfo: {
                            readonly hasNextPage: boolean | null;
                        } | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly id: string;
                                readonly __typename: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                }> | null;
                readonly peopleEntities?: ReadonlyArray<{
                    readonly entity: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly name: string | null;
                        readonly websiteUrl: string | null;
                        readonly industry: string | null;
                        readonly fundingRound: string | null;
                        readonly activities: ReadonlyArray<{
                            readonly kind: EntityActivityKind | null;
                            readonly label: string | null;
                        }> | null;
                        readonly people: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly role: string | null;
                                readonly person: {
                                    readonly __typename: string;
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly edges: ReadonlyArray<{
                                            readonly preview: {
                                                readonly link: string | null;
                                                readonly kind: PreviewKind | null;
                                                readonly mediaAsset: {
                                                    readonly files: ReadonlyArray<{
                                                        readonly name: string | null;
                                                        readonly path: string | null;
                                                    }> | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                };
                            }> | null;
                        } | null;
                        readonly investmentsBy: ReadonlyArray<{
                            readonly amount: string | null;
                            readonly link: string | null;
                            readonly deckUrl: string | null;
                            readonly investmentDate: unknown | null;
                        }> | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                    readonly person: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                }> | null;
                readonly summary?: string | null;
                readonly url?: string | null;
            } & ({
                readonly __typename: "Event";
                readonly id: string;
                readonly name: string | null;
                readonly description: string | null;
                readonly end: unknown | null;
                readonly start: unknown | null;
                readonly status: EventStatusKind | null;
                readonly externalId: string | null;
                readonly mediaExternalId: string | null;
                readonly created: unknown | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly people: ReadonlyArray<{
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly landingPageUrl: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly entities: ReadonlyArray<{
                    readonly __typename: string;
                    readonly id: string;
                    readonly name: string | null;
                    readonly description: string | null;
                    readonly landingPageUrl: string | null;
                    readonly founded: unknown | null;
                    readonly industry: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly noOfEmployees: {
                        readonly maximum: number | null;
                        readonly minimum: number | null;
                        readonly isGreaterThan: boolean | null;
                        readonly isLessThan: boolean | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly pitchOriginalMedia: {
                        readonly id: string;
                    } | null;
                    readonly opportunities: {
                        readonly productAndServices: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly careers: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly collaboration: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                    } | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly pageInfo: {
                            readonly hasNextPage: boolean | null;
                        } | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly id: string;
                                readonly __typename: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                }> | null;
                readonly peopleEntities: ReadonlyArray<{
                    readonly entity: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly name: string | null;
                        readonly websiteUrl: string | null;
                        readonly industry: string | null;
                        readonly fundingRound: string | null;
                        readonly activities: ReadonlyArray<{
                            readonly kind: EntityActivityKind | null;
                            readonly label: string | null;
                        }> | null;
                        readonly people: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly role: string | null;
                                readonly person: {
                                    readonly __typename: string;
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly edges: ReadonlyArray<{
                                            readonly preview: {
                                                readonly link: string | null;
                                                readonly kind: PreviewKind | null;
                                                readonly mediaAsset: {
                                                    readonly files: ReadonlyArray<{
                                                        readonly name: string | null;
                                                        readonly path: string | null;
                                                    }> | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                };
                            }> | null;
                        } | null;
                        readonly investmentsBy: ReadonlyArray<{
                            readonly amount: string | null;
                            readonly link: string | null;
                            readonly deckUrl: string | null;
                            readonly investmentDate: unknown | null;
                        }> | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                    readonly person: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                }> | null;
                readonly summary: string | null;
                readonly url: string | null;
            } | {
                /*This will never be '% other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            })) | null;
        } & ({
            readonly id: string;
            readonly __typename: "RSVPRequest";
            readonly status: string | null;
            readonly item: ({
                readonly __typename: "Event";
                readonly id?: string;
                readonly name?: string | null;
                readonly description?: string | null;
                readonly end?: unknown | null;
                readonly start?: unknown | null;
                readonly status?: EventStatusKind | null;
                readonly externalId?: string | null;
                readonly mediaExternalId?: string | null;
                readonly created?: unknown | null;
                readonly previews?: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly people?: ReadonlyArray<{
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly landingPageUrl: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly entities?: ReadonlyArray<{
                    readonly __typename: string;
                    readonly id: string;
                    readonly name: string | null;
                    readonly description: string | null;
                    readonly landingPageUrl: string | null;
                    readonly founded: unknown | null;
                    readonly industry: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly noOfEmployees: {
                        readonly maximum: number | null;
                        readonly minimum: number | null;
                        readonly isGreaterThan: boolean | null;
                        readonly isLessThan: boolean | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly pitchOriginalMedia: {
                        readonly id: string;
                    } | null;
                    readonly opportunities: {
                        readonly productAndServices: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly careers: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly collaboration: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                    } | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly pageInfo: {
                            readonly hasNextPage: boolean | null;
                        } | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly id: string;
                                readonly __typename: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                }> | null;
                readonly peopleEntities?: ReadonlyArray<{
                    readonly entity: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly name: string | null;
                        readonly websiteUrl: string | null;
                        readonly industry: string | null;
                        readonly fundingRound: string | null;
                        readonly activities: ReadonlyArray<{
                            readonly kind: EntityActivityKind | null;
                            readonly label: string | null;
                        }> | null;
                        readonly people: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly role: string | null;
                                readonly person: {
                                    readonly __typename: string;
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly edges: ReadonlyArray<{
                                            readonly preview: {
                                                readonly link: string | null;
                                                readonly kind: PreviewKind | null;
                                                readonly mediaAsset: {
                                                    readonly files: ReadonlyArray<{
                                                        readonly name: string | null;
                                                        readonly path: string | null;
                                                    }> | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                };
                            }> | null;
                        } | null;
                        readonly investmentsBy: ReadonlyArray<{
                            readonly amount: string | null;
                            readonly link: string | null;
                            readonly deckUrl: string | null;
                            readonly investmentDate: unknown | null;
                        }> | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                    readonly person: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                }> | null;
                readonly summary?: string | null;
                readonly url?: string | null;
            } & ({
                readonly __typename: "Event";
                readonly id: string;
                readonly name: string | null;
                readonly description: string | null;
                readonly end: unknown | null;
                readonly start: unknown | null;
                readonly status: EventStatusKind | null;
                readonly externalId: string | null;
                readonly mediaExternalId: string | null;
                readonly created: unknown | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly people: ReadonlyArray<{
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly landingPageUrl: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly entities: ReadonlyArray<{
                    readonly __typename: string;
                    readonly id: string;
                    readonly name: string | null;
                    readonly description: string | null;
                    readonly landingPageUrl: string | null;
                    readonly founded: unknown | null;
                    readonly industry: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly noOfEmployees: {
                        readonly maximum: number | null;
                        readonly minimum: number | null;
                        readonly isGreaterThan: boolean | null;
                        readonly isLessThan: boolean | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly pitchOriginalMedia: {
                        readonly id: string;
                    } | null;
                    readonly opportunities: {
                        readonly productAndServices: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly careers: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                        readonly collaboration: {
                            readonly description: string | null;
                            readonly link: string | null;
                            readonly email: string | null;
                        } | null;
                    } | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly pageInfo: {
                            readonly hasNextPage: boolean | null;
                        } | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly id: string;
                                readonly __typename: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                }> | null;
                readonly peopleEntities: ReadonlyArray<{
                    readonly entity: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly name: string | null;
                        readonly websiteUrl: string | null;
                        readonly industry: string | null;
                        readonly fundingRound: string | null;
                        readonly activities: ReadonlyArray<{
                            readonly kind: EntityActivityKind | null;
                            readonly label: string | null;
                        }> | null;
                        readonly people: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly role: string | null;
                                readonly person: {
                                    readonly __typename: string;
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly edges: ReadonlyArray<{
                                            readonly preview: {
                                                readonly link: string | null;
                                                readonly kind: PreviewKind | null;
                                                readonly mediaAsset: {
                                                    readonly files: ReadonlyArray<{
                                                        readonly name: string | null;
                                                        readonly path: string | null;
                                                    }> | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                };
                            }> | null;
                        } | null;
                        readonly investmentsBy: ReadonlyArray<{
                            readonly amount: string | null;
                            readonly link: string | null;
                            readonly deckUrl: string | null;
                            readonly investmentDate: unknown | null;
                        }> | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                    readonly person: {
                        readonly __typename: string;
                        readonly landingPageUrl: string | null;
                        readonly id: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | null;
                }> | null;
                readonly summary: string | null;
                readonly url: string | null;
            } | {
                /*This will never be '% other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            })) | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type createRsvpRequestMutation = {
    readonly response: createRsvpRequestMutationResponse;
    readonly variables: createRsvpRequestMutationVariables;
};



/*
mutation createRsvpRequestMutation(
  $input: CreateUpdatePitchRequestInput!
) {
  createRSVPRequest(input: $input) {
    errors {
      id
      location
    }
    hasErrors
    userRequest {
      __typename
      ... on RSVPRequest {
        id
        __typename
        status
        item {
          __typename
          ... on Event {
            __typename
            id
            name
            description
            end
            start
            status
            externalId
            mediaExternalId
            created
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
            people {
              id
              fullName
              responsibility
              landingPageUrl
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
            }
            entities {
              __typename
              id
              name
              description
              landingPageUrl
              founded
              industry
              activities {
                kind
                label
                id
              }
              noOfEmployees {
                maximum
                minimum
                isGreaterThan
                isLessThan
              }
              investmentsBy {
                amount
                link
                deckUrl
                investmentDate
                id
              }
              pitchOriginalMedia {
                id
              }
              opportunities {
                productAndServices {
                  description
                  link
                  email
                }
                careers {
                  description
                  link
                  email
                }
                collaboration {
                  description
                  link
                  email
                }
                id
              }
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
              people(first: 24) {
                count
                pageInfo {
                  hasNextPage
                }
                edges {
                  role
                  person {
                    id
                    __typename
                    fullName
                    responsibility
                    description
                    landingPageUrl
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                  }
                }
              }
            }
            peopleEntities {
              entity {
                __typename
                landingPageUrl
                id
                name
                websiteUrl
                industry
                fundingRound
                activities {
                  kind
                  label
                  id
                }
                people {
                  count
                  edges {
                    role
                    person {
                      __typename
                      id
                      fullName
                      landingPageUrl
                      previews {
                        edges {
                          preview {
                            link
                            kind
                            mediaAsset {
                              files {
                                name
                                path
                                id
                              }
                              topLevelMediaType {
                                kind
                                id
                              }
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                }
                investmentsBy {
                  amount
                  link
                  deckUrl
                  investmentDate
                  id
                }
                previews {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
              }
              person {
                __typename
                landingPageUrl
                id
                fullName
                responsibility
                description
                previews {
                  count
                  edges {
                    cursor
                    preview {
                      mediaAsset {
                        id
                        files {
                          id
                          name
                          heightInPixels
                          widthInPixels
                          path
                          status {
                            kind
                            id
                          }
                        }
                        state {
                          kind
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                      }
                      kind
                      link
                    }
                  }
                }
              }
            }
            summary
            url
          }
          ... on Node {
            id
          }
          ... on SearchHit {
            id
          }
          ... on Tag {
            id
          }
        }
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUpdatePitchRequestInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mediaExternalId",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v20/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v7/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v20/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v20/*: any*/)
                },
                (v21/*: any*/)
              ]
            },
            (v19/*: any*/),
            (v22/*: any*/)
          ]
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "founded",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "activities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityActivity",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v29/*: any*/)
  ]
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "noOfEmployees",
  "storageKey": null,
  "args": null,
  "concreteType": "Range",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "maximum",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "minimum",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isGreaterThan",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLessThan",
      "args": null,
      "storageKey": null
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deckUrl",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentDate",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "investmentsBy",
  "storageKey": null,
  "args": null,
  "concreteType": "Investment",
  "plural": true,
  "selections": [
    (v32/*: any*/),
    (v22/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pitchOriginalMedia",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoStory",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ]
},
v37 = [
  (v8/*: any*/),
  (v22/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }
],
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productAndServices",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "careers",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v37/*: any*/)
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "collaboration",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v37/*: any*/)
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  }
],
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "summary",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v48 = [
  (v19/*: any*/),
  (v2/*: any*/)
],
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v7/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v48/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v48/*: any*/)
                },
                (v49/*: any*/)
              ]
            },
            (v19/*: any*/),
            (v22/*: any*/)
          ]
        }
      ]
    }
  ]
},
v51 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "activities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityActivity",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v29/*: any*/),
    (v2/*: any*/)
  ]
},
v52 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "investmentsBy",
  "storageKey": null,
  "args": null,
  "concreteType": "Investment",
  "plural": true,
  "selections": [
    (v32/*: any*/),
    (v22/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v2/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createRsvpRequestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createRSVPRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateUpdateUserRequestPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userRequest",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "RSVPRequest",
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "Event",
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v6/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "people",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Person",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "entities",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Entity",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "opportunities",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Opportunities",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/)
                                ]
                              },
                              (v23/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "people",
                                "storageKey": "people(first:24)",
                                "args": (v41/*: any*/),
                                "concreteType": "EntityOwnersConnection",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v42/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EntityOwner",
                                    "plural": true,
                                    "selections": [
                                      (v43/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "person",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v5/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v8/*: any*/),
                                          (v26/*: any*/),
                                          (v23/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "peopleEntities",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EntityPerson",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "entity",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Entity",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v26/*: any*/),
                                  (v2/*: any*/),
                                  (v7/*: any*/),
                                  (v44/*: any*/),
                                  (v28/*: any*/),
                                  (v45/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "people",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EntityOwnersConnection",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "EntityOwner",
                                        "plural": true,
                                        "selections": [
                                          (v43/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "person",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v2/*: any*/),
                                              (v24/*: any*/),
                                              (v26/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "previews",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "PreviewsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PreviewEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "preview",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Preview",
                                                        "plural": false,
                                                        "selections": [
                                                          (v22/*: any*/),
                                                          (v19/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "mediaAsset",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "MediaAsset",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "files",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "MediaAssetFile",
                                                                "plural": true,
                                                                "selections": [
                                                                  (v7/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              },
                                                              (v21/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v35/*: any*/),
                                  (v23/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "person",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Person",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v26/*: any*/),
                                  (v2/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v8/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "createRsvpRequestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createRSVPRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateUpdateUserRequestPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userRequest",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "RSVPRequest",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "Event",
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v6/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v50/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "people",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Person",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v50/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "entities",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Entity",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v51/*: any*/),
                              (v31/*: any*/),
                              (v52/*: any*/),
                              (v36/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "opportunities",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Opportunities",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v2/*: any*/)
                                ]
                              },
                              (v50/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "people",
                                "storageKey": "people(first:24)",
                                "args": (v41/*: any*/),
                                "concreteType": "EntityOwnersConnection",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v42/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EntityOwner",
                                    "plural": true,
                                    "selections": [
                                      (v43/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "person",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v5/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v8/*: any*/),
                                          (v26/*: any*/),
                                          (v50/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "peopleEntities",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EntityPerson",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "entity",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Entity",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v26/*: any*/),
                                  (v2/*: any*/),
                                  (v7/*: any*/),
                                  (v44/*: any*/),
                                  (v28/*: any*/),
                                  (v45/*: any*/),
                                  (v51/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "people",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EntityOwnersConnection",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "EntityOwner",
                                        "plural": true,
                                        "selections": [
                                          (v43/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "person",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v2/*: any*/),
                                              (v24/*: any*/),
                                              (v26/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "previews",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "PreviewsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PreviewEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "preview",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Preview",
                                                        "plural": false,
                                                        "selections": [
                                                          (v22/*: any*/),
                                                          (v19/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "mediaAsset",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "MediaAsset",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "files",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "MediaAssetFile",
                                                                "plural": true,
                                                                "selections": [
                                                                  (v7/*: any*/),
                                                                  (v18/*: any*/),
                                                                  (v2/*: any*/)
                                                                ]
                                                              },
                                                              (v49/*: any*/),
                                                              (v2/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v52/*: any*/),
                                  (v50/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "person",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Person",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v26/*: any*/),
                                  (v2/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v8/*: any*/),
                                  (v50/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "createRsvpRequestMutation",
    "id": null,
    "text": "mutation createRsvpRequestMutation(\n  $input: CreateUpdatePitchRequestInput!\n) {\n  createRSVPRequest(input: $input) {\n    errors {\n      id\n      location\n    }\n    hasErrors\n    userRequest {\n      __typename\n      ... on RSVPRequest {\n        id\n        __typename\n        status\n        item {\n          __typename\n          ... on Event {\n            __typename\n            id\n            name\n            description\n            end\n            start\n            status\n            externalId\n            mediaExternalId\n            created\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n            people {\n              id\n              fullName\n              responsibility\n              landingPageUrl\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n            }\n            entities {\n              __typename\n              id\n              name\n              description\n              landingPageUrl\n              founded\n              industry\n              activities {\n                kind\n                label\n                id\n              }\n              noOfEmployees {\n                maximum\n                minimum\n                isGreaterThan\n                isLessThan\n              }\n              investmentsBy {\n                amount\n                link\n                deckUrl\n                investmentDate\n                id\n              }\n              pitchOriginalMedia {\n                id\n              }\n              opportunities {\n                productAndServices {\n                  description\n                  link\n                  email\n                }\n                careers {\n                  description\n                  link\n                  email\n                }\n                collaboration {\n                  description\n                  link\n                  email\n                }\n                id\n              }\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n              people(first: 24) {\n                count\n                pageInfo {\n                  hasNextPage\n                }\n                edges {\n                  role\n                  person {\n                    id\n                    __typename\n                    fullName\n                    responsibility\n                    description\n                    landingPageUrl\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            peopleEntities {\n              entity {\n                __typename\n                landingPageUrl\n                id\n                name\n                websiteUrl\n                industry\n                fundingRound\n                activities {\n                  kind\n                  label\n                  id\n                }\n                people {\n                  count\n                  edges {\n                    role\n                    person {\n                      __typename\n                      id\n                      fullName\n                      landingPageUrl\n                      previews {\n                        edges {\n                          preview {\n                            link\n                            kind\n                            mediaAsset {\n                              files {\n                                name\n                                path\n                                id\n                              }\n                              topLevelMediaType {\n                                kind\n                                id\n                              }\n                              id\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n                investmentsBy {\n                  amount\n                  link\n                  deckUrl\n                  investmentDate\n                  id\n                }\n                previews {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n              }\n              person {\n                __typename\n                landingPageUrl\n                id\n                fullName\n                responsibility\n                description\n                previews {\n                  count\n                  edges {\n                    cursor\n                    preview {\n                      mediaAsset {\n                        id\n                        files {\n                          id\n                          name\n                          heightInPixels\n                          widthInPixels\n                          path\n                          status {\n                            kind\n                            id\n                          }\n                        }\n                        state {\n                          kind\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                      }\n                      kind\n                      link\n                    }\n                  }\n                }\n              }\n            }\n            summary\n            url\n          }\n          ... on Node {\n            id\n          }\n          ... on SearchHit {\n            id\n          }\n          ... on Tag {\n            id\n          }\n        }\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '578159e60d166ca8b620a6f0bd1b2691';
export default node;
